import { routes } from './routes';
import type { AuthUser, RoleCode } from '@/types';

/** Role code → workspace cabinet path (merged from Topbar + CategoryRolesStrip). */
export const ROLE_CABINET_ROUTES: Partial<Record<RoleCode | string, string>> = {
  SYSTEM_OWNER: routes.owner,
  ADVISOR: routes.advisor,
  SUPERVISOR: routes.supervisor,
  TEACHER: routes.teacher,
  RESEARCHER: routes.researcher,
  OPERATIONS_PARTNER: routes.operationsPartner,
  RESEARCH_PARTNER: routes.partner,
  MENTOR_PARTNER: routes.partner,
  DEPARTMENT_HEAD: routes.departmentHead,
  DEPARTMENT_LAB: routes.departmentLab,
  DEPARTMENT_ASSISTANT: routes.departmentLab,
  STUDENT: routes.supervisedStudent,
  SUPERVISED_STUDENT: routes.supervisedStudent,
  COURSE_STUDENT: routes.courseStudent,
  DOCTORAL_STUDENT: routes.doctoral,
  LEARNER: routes.learner,
  AUTHOR: routes.author,
  CLIENT: routes.client,
  PROJECT_EDITOR: routes.editor,
  PROJECT_MEMBER: routes.projectMember,
};

/** Category code → workspace cabinet path. */
export const CATEGORY_CABINET_ROUTES: Record<string, string> = {
  OPERATIONS_PARTNER: routes.operationsPartner,
  RESEARCH_PARTNER: routes.partner,
  MENTOR_PARTNER: routes.partner,
  DEPARTMENT_HEAD: routes.departmentHead,
  DEPARTMENT_ASSISTANT: routes.departmentLab,
  DEPARTMENT_LAB: routes.departmentLab,
  DOCTORAL_STUDENT: routes.doctoral,
  LEARNER: routes.learner,
  SUPERVISED_STUDENT: routes.supervisedStudent,
  STUDENT: routes.supervisedStudent,
  COURSE_STUDENT: routes.courseStudent,
  AUTHOR: routes.author,
  CLIENT: routes.client,
  PROJECT_EDITOR: routes.editor,
  EDITOR: routes.editor,
  PROJECT_MEMBER: routes.projectMember,
  TEACHER: routes.teacher,
};

export const getRouteForRoleOrCategory = (code: string | null | undefined): string | null => {
  if (!code || code === 'ALL_USERS') return null;
  return ROLE_CABINET_ROUTES[code] ?? CATEGORY_CABINET_ROUTES[code] ?? null;
};

/**
 * Primary cabinet for an authenticated user: activeRole, then roles, then categories.
 * Falls back to home (not `/app`) to avoid redirect loops.
 */
export const getCabinetRouteForUser = (
  user: Pick<AuthUser, 'activeRole' | 'roles' | 'categories'>,
): string => {
  const roles = Array.isArray(user.roles) ? user.roles : [];
  const categories = Array.isArray(user.categories) ? user.categories : [];
  const candidates = [user.activeRole, ...roles, ...categories];
  for (const code of candidates) {
    const href = getRouteForRoleOrCategory(code);
    if (href) return href;
  }
  return routes.home;
};
